import styled from "styled-components"

const Logo = styled.img`
  display: block;
  margin: 0;

  ${({ theme }) => theme.desktop`
    height: 44px;
  `}
`

export default Logo
